import { render, staticRenderFns } from "./lostCard.vue?vue&type=template&id=4a0ff9d5&scoped=true&"
import script from "./lostCard.vue?vue&type=script&lang=js&"
export * from "./lostCard.vue?vue&type=script&lang=js&"
import style0 from "./lostCard.vue?vue&type=style&index=0&id=4a0ff9d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ff9d5",
  null
  
)

export default component.exports